import { render, staticRenderFns } from "./SubmitButtonCpt.vue?vue&type=template&id=4c581bec&scoped=true&"
import script from "./SubmitButtonCpt.vue?vue&type=script&lang=ts&"
export * from "./SubmitButtonCpt.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitButtonCpt.vue?vue&type=style&index=0&id=4c581bec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c581bec",
  null
  
)

export default component.exports